import { useQuery } from '@tanstack/react-query';

import { API_ROUTES } from '@/query/routes';
import axiosInstance from '@/utils/api/axios-instance';

interface ReleaseNoteListParams {
  page?: number;
  limit?: number;
}
const useGetReleaseNoteLists = (params: ReleaseNoteListParams) =>
  useQuery({
    queryKey: ['release-note-lists', params],
    queryFn: async () => {
      const { page, limit } = params;
      const response = await axiosInstance.get(API_ROUTES.releaseNoteLists(page, limit));

      return response.data;
    },
    gcTime: 10 * 60 * 1000,
    staleTime: 10 * 60 * 1000,
  });

export default useGetReleaseNoteLists;
